import { SportsRequest, DateRange, EventsCountByTagRequest } from "sb-bff-integration";
export const preLiveSportBFFQueryFactoryConstructor = (dateFactory) => {
    return () => ({
        eventState: SportsRequest.EventStateEnum.PreLive,
        dateRange: {
            from: new dateFactory(),
            timeRange: DateRange.TimeRangeEnum.SixHours,
        }
    });
};
export const liveSportBFFQueryFactory = () => {
    return {
        eventState: SportsRequest.EventStateEnum.Live,
    };
};
export const todayLiveStreamingQueryFactory = (from) => preLiveLiveStreamingQueryFactory(from, DateRange.TimeRangeEnum.OneDay);
export const upcomingLiveStreamingQueryFactory = (from) => preLiveLiveStreamingQueryFactory(from, DateRange.TimeRangeEnum.SixHours);
const preLiveLiveStreamingQueryFactory = (from, range) => {
    return {
        eventTags: [EventsCountByTagRequest.EventTagsEnum.LiveStreaming],
        eventState: EventsCountByTagRequest.EventStateEnum.PreLive,
        eventTypes: [EventsCountByTagRequest.EventTypesEnum.Fixture],
        dateRange: {
            from,
            timeRange: range
        }
    };
};
export const liveLiveStreamingQueryFactory = () => {
    return {
        eventTags: [EventsCountByTagRequest.EventTagsEnum.LiveStreaming],
        eventTypes: [EventsCountByTagRequest.EventTypesEnum.Fixture],
        eventState: EventsCountByTagRequest.EventStateEnum.Live
    };
};
export const todaySportBFFQueryFactory = (from) => {
    return {
        eventState: SportsRequest.EventStateEnum.Mixed,
        dateRange: {
            from,
            timeRange: DateRange.TimeRangeEnum.OneDay,
        }
    };
};
export const personalizedSportBFFQueryFactory = (maxNumberOfSports, maxNumberOfEventsPerSport, regionId) => {
    return {
        numberOfSports: maxNumberOfSports,
        numberOfEventsPerSport: maxNumberOfEventsPerSport,
        regionCode: regionId
    };
};
//# sourceMappingURL=SportBFFQueries.js.map